import type { ReactNode } from "react"
import Logo from "@rawa/ui/assets/logo.svg?react"
import styles from "./SadLayout.module.scss"

type Props = {
  children: ReactNode
  heading?: ReactNode
}

export function SadLayout({ children, heading }: Props) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Logo
          role="img"
          className={styles.logo}
          aria-label="Relationships Australia WA"
        />
        {heading}
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  )
}
